import {
  CatIconCancelUndo,
  CatIconReplace,
  CatIconWrench,
  CatIconCube
} from 'components/blocks-components';
import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';

interface ProductCardBottomIconsProps {
  isNonReturnable: boolean;
  isReplacedPart: boolean;
  isRemanufacturedPart: boolean;
  isKit: boolean;
}

const ProductCardBottomIcons = ({
  isNonReturnable,
  isReplacedPart,
  isRemanufacturedPart,
  isKit
}: ProductCardBottomIconsProps) => (
  <div
    className={cx(
      'd-flex gap-2',
      styles['product-comparison__card-bottom-icons']
    )}
  >
    {isNonReturnable && <CatIconCancelUndo data-testid="non-returnable-icon" />}
    {isReplacedPart && <CatIconReplace data-testid="replaced-part-icon" />}
    {isRemanufacturedPart && (
      <CatIconWrench data-testid="remanufactured-part-icon" />
    )}
    {isKit && <CatIconCube data-testid="kit-icon" />}
  </div>
);

export default ProductCardBottomIcons;
